(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doc-lookup-storefront-poc"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class DocLookup {
      constructor(element) {
        this.element = element;
        this.form = element.querySelector('[data-doc-lookup-form]');
        this.input = element.querySelector('[data-doc-lookup-input]');
        this.status = element.querySelector('[data-doc-lookup-status]');
        this.result = element.querySelector('[data-doc-lookup-result]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.endpoint = `https://${element.dataset.shopDomain}/api/${element.dataset.apiVersion}/graphql.json`;
        this.token = element.dataset.storefrontToken;
        this.metaobjectType = element.dataset.metaobjectType;
        this.text = {
          enterSku: element.dataset.textEnterSku,
          missingToken: element.dataset.textMissingToken,
          searching: element.dataset.textSearching,
          notFound: element.dataset.textNotFound,
          found: element.dataset.textFound,
          download: element.dataset.textDownload,
          error: element.dataset.textError
        };

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      normalizeSku(value) {
        return value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }

      splitAlphaNumber(value) {
        return value.replace(/^([a-z]+)-?([0-9].*)$/, '$1-$2');
      }

      getParentHandleCandidates(parts) {
        if (parts.length === 0) {
          return [];
        }

        let parent = parts[0];

        if (parts.length > 1 && /^[a-z]+$/.test(parts[0]) && /^[0-9]+$/.test(parts[1])) {
          parent = `${parts[0]}-${parts[1]}`;
        }

        const compactParent = parent.replace(/-/g, '');
        return [parent, compactParent, this.splitAlphaNumber(compactParent)];
      }

      getHandleCandidates(value) {
        const normalized = this.normalizeSku(value);
        const parts = normalized.split('-').filter(Boolean);
        const compact = normalized.replace(/-/g, '');
        const isVariantSku = parts.length > 2 || (parts.length === 2 && /^[a-z]+[0-9]+$/.test(parts[0]));
        const candidates = [normalized, this.splitAlphaNumber(normalized)];

        if (!isVariantSku) {
          candidates.push(compact, this.splitAlphaNumber(compact));
        }

        if (isVariantSku) {
          candidates.push(...this.getParentHandleCandidates(parts));
        }

        return [...new Set(candidates.filter(Boolean))];
      }

      setStatus(message) {
        this.status.textContent = message;
      }

      clearResult() {
        this.result.hidden = true;
        this.result.replaceChildren();
      }

      async onSubmit(event) {
        event.preventDefault();
        this.clearResult();

        const sku = this.input.value.trim();
        const handleCandidates = this.getHandleCandidates(sku);

        if (!sku || handleCandidates.length === 0) {
          this.setStatus(this.text.enterSku);
          return;
        }

        if (!this.token) {
                      this.setStatus(this.text.missingToken);
          return;
        }

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.setStatus(this.text.searching);

        try {
          const data = await this.fetchFirstDeclaration(handleCandidates);
          const metaobject = data.data && data.data.metaobject;
          const fields = this.mapFields(metaobject);
          const docLink = fields.doc_url || fields.doc_link || (metaobject && metaobject.docUrl && metaobject.docUrl.value) || (metaobject && metaobject.docLink && metaobject.docLink.value);
          const docName = fields.doc_name || (metaobject && metaobject.docName && metaobject.docName.value);
          const navName = fields.nav_name || (metaobject && metaobject.navName && metaobject.navName.value);
          const resultSku = fields.sku || (metaobject && metaobject.sku && metaobject.sku.value);
          const displaySku = (resultSku || sku).toUpperCase();

          if (!docLink) {
            this.setStatus(this.text.notFound.replace('[sku]', sku));
            return;
          }

          if (navName || docName) {
            const meta = document.createElement('p');
            meta.className = 'doc-lookup__meta';
            meta.textContent = [displaySku, navName || docName].filter(Boolean).join(' - ');
            this.result.append(meta);
          }

          const link = document.createElement('a');
          link.className = 'btn btn--primary doc-lookup__download';
          link.href = docLink;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = this.text.download;

          this.result.append(link);
          this.result.hidden = false;
          this.setStatus(this.text.found.replace('[sku]', displaySku));
        } catch (error) {
          this.setStatus(this.text.error);
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }

      mapFields(metaobject) {
        if (!metaobject || !Array.isArray(metaobject.fields)) {
          return {};
        }

        return metaobject.fields.reduce((fields, field) => {
          fields[field.key] = field.value;
          return fields;
        }, {});
      }

      async fetchFirstDeclaration(handles) {
        let lastResponse;

        for (const handle of handles) {
          const data = await this.fetchDeclaration(handle);
          lastResponse = data;

          if (data.data && data.data.metaobject) {
            return data;
          }
        }

        return lastResponse;
      }

      async fetchDeclaration(handle) {
        const query = `
          query DocDeclarationBySku($handle: MetaobjectHandleInput!) {
            metaobject(handle: $handle) {
              handle
              sku: field(key: "sku") {
                value
              }
              navName: field(key: "nav_name") {
                value
              }
              docName: field(key: "doc_name") {
                value
              }
              docUrl: field(key: "doc_url") {
                value
              }
              docLink: field(key: "doc_link") {
                value
              }
              fields {
                key
                value
              }
            }
          }
        `;

        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.token
          },
          body: JSON.stringify({
            query,
            variables: {
              handle: {
                type: this.metaobjectType,
                handle
              }
            }
          })
        });

        const json = await response.json();

        if (!response.ok || json.errors) {
          throw new Error('Request failed');
        }

        return json;
      }
    }

    function initDocLookup(container) {
      container.querySelectorAll('[data-doc-lookup-storefront], [data-doc-lookup][data-storefront-token]').forEach((element) => {
        if (element.dataset.docLookupStorefrontInitialized === 'true') {
          return;
        }

        element.dataset.docLookupStorefrontInitialized = 'true';
        new DocLookup(element);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initDocLookup(document);
      });
    } else {
      initDocLookup(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initDocLookup(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
